"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/tokenController',["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";

    var TokenController = function () {
        function TokenController() {
            _classCallCheck(this, TokenController);

            this.baseRoute = '/api/Account/';
        }

        _createClass(TokenController, [{
            key: "refreshToken",
            value: function refreshToken(data) {
                var deferred = $.Deferred();
                var options = {
                    method: 'POST',
                    url: this.baseRoute + 'Token',
                    data: data
                };
                var promise = $.ajax(options);
                promise.done(function (tokenResponse) {
                    deferred.resolve(tokenResponse);
                }).fail(function (httpObj) {
                    deferred.reject(httpObj.responseJSON);
                });
                return deferred;
            }
        }]);

        return TokenController;
    }();

    return new TokenController();
});
//# sourceMappingURL=tokenController.js.map;
